import {
	atom,
} from 'recoil';

const keymastersPotAdvancedModeAtom = atom({
	key: 'keymastersPotAdvancedMode', // unique ID (with respect to other atoms/selectors)
	default: false, // default value (aka initial value)
});

export default keymastersPotAdvancedModeAtom;
